export const PLAN_TYPES = {
  CORE: 'Core',
  ADVANCED: 'Advanced',
  ENTERPRISE: 'Enterprise',
} as const

export type PlanTypes = (typeof PLAN_TYPES)[keyof typeof PLAN_TYPES]
